export const ru = {
    RUB: 'Российские рубли',
    currency: 'Валюта',
    default: 'нет',
    from: 'от',
    prefix: 'Префикс',
    price: 'Цена',
    priceOld: 'Старая цена',
    to: 'до'
};
